module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Baptiste_1.a358132.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Baptiste_1.jpg
// module id = pwZ2
// module chunks = 0